import React, { useState, useEffect } from "react";

import generateForm from "./generateForm";

const OrderSearchForm = ({ onClick, prefillData, setPrefillData }) => {

  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [firstSix, setFirstSix] = useState("");
  const [lastFour, setLastFour] = useState("");
  const [creditCardID, setCreditCardID] = useState("");
  const [city, setCity] = useState("");
  const [zip, setZip] = useState("");
  const [cId, setCid] = useState("");
  const [bId, setbId] = useState("");
  const [oId, setOid] = useState("");
  const [state, setState] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);
  const [membershipEmail, setMembershipEmail] = useState("");
  const [scn, setScn] = useState("");
  const [sca, setSca] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const [includeInactiveCustomers, setIncludeInactiveCustomers] = useState(false);

  useEffect(() => {
    setPhone(prefillData?.phone || "");
      setEmail(prefillData?.email || "");
      setFirstName(prefillData?.firstName || "");
      setLastName(prefillData?.lastName || "");
      setFirstSix(prefillData?.firstSix || "");
      setLastFour(prefillData?.lastFour || "");
      setCreditCardID(prefillData?.cardTypeId || "");
      setCity(prefillData?.city || "");
      setZip(prefillData?.zip || "");
      setCid(prefillData?.customerId || "");
      setbId(prefillData?.brandId || "");
      setOid(prefillData?.orderId || "");
      setState(prefillData?.state || "");
      setOrderStatus(prefillData?.orderStatusId || "");
    setStartDate(prefillData?.startDate);
    setEndDate(prefillData?.endDate);
    setMembershipEmail(prefillData?.membershipEmail || "");
    setScn(prefillData?.scn || "");
    setSca(prefillData?.sca || "");
    setIpAddress(prefillData?.ipAddress || "");
    setIncludeInactiveCustomers(prefillData?.includeInactiveCustomers || false);
  }, [prefillData])

  const clearFields = () => {
    setPrefillData(null)
    setPhone('');
    setEmail('');
    setFirstName('');
    setLastName('');
    setFirstSix('');
    setLastFour('');
    setCreditCardID('');
    setCity('');
    setZip('');
    setCid('');
    setbId('');
    setOid('');
    setState('');
    setOrderStatus('');
    setStartDate(undefined);
    setEndDate(undefined);
    setMembershipEmail('');
    setScn('');
    setSca('');
    setIpAddress('');
    setIncludeInactiveCustomers(false);
    localStorage.removeItem("previousSearchResults");
  }

  return (
    <div
      className="search-form-box"
      style={{
        background: "#1137535e",
        padding: "1rem",
        borderRadius: "10px",
      }}
    >
      {generateForm(
        phone,
        setPhone,
        email,
        setEmail,
        firstName,
        setFirstName,
        lastName,
        setLastName,
        firstSix,
        setFirstSix,
        lastFour,
        setLastFour,
        creditCardID,
        setCreditCardID,
        bId,
        setbId,
        city,
        setCity,
        zip,
        setZip,
        cId,
        setCid,
        oId,
        setOid,
        state,
        setState,
        orderStatus,
        setOrderStatus,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        membershipEmail,
        setMembershipEmail,
        scn,
        setScn,
        sca,
        setSca,
        ipAddress,
        setIpAddress,
        includeInactiveCustomers,
        setIncludeInactiveCustomers
      )}
      {prefillData && <button
        onClick={() => clearFields()}
        className="subBtn"
      >
        <span>Clear all Fields</span>
      </button>}
      <button
        onClick={() =>
          onClick(
            phone,
            email,
            firstName,
            lastName,
            firstSix,
            lastFour,
            creditCardID,
            city,
            zip,
            cId,
            bId,
            oId,
            state,
            orderStatus,
            startDate,
            endDate,
            membershipEmail,
            scn,
            sca,
            ipAddress,
            includeInactiveCustomers
          )
        }
        className="subBtn"
      >
        <span>Submit</span>
      </button>
      
    </div>
  );
};

export default OrderSearchForm;
